<template>
    <div :class="{ 'transform -translate-y-full' : !showModal }" class="fixed overflow-x-hidden overflow-y-auto inset-0 flex justify-center items-center z-50 bg-gray-800 bg-opacity-75 transition ease-in-out duration-200">
        <div class="relative w-full max-w-md max-h-full">
            <div class="shadow-lg bg-white border-2 border-black border-solid rounded-md p-3">
                <div class="flex items-start justify-between border-b pb-3 rounded-t dark:border-gray-600">
                    <h3 class="flex gap-2 items-center text-xl font-semibold text-gray-900 dark:text-white">
                        <div class="bg-blue-500 w-10 h-10 flex items-center justify-center rounded-full text-white">
                            <SvgIcons iconname="cog"></SvgIcons>
                        </div>
                        Change Password
                    </h3>
                    <button @click="$emit('onClose')" class="bg-red-500 w-8 h-8 flex items-center justify-center rounded-full">
                        <SvgIcons iconname="x-mark"></SvgIcons>
                    </button>
                </div>
                <div class="mt-5">
                    <ValidationViewVue v-slot="{validated, isvalid}" :inputs="JSON.stringify(input)" :vinputs="JSON.stringify(vinput)">
                        <InputTemplate v-slot="{label, textbox, button, validation}">
                            <div class="mb-5">
                                <div class="flex gap-2 items-center justify-start">
                                    <label class="mt-2" :class="label">Old Password</label>
                                </div>
                                <input type="password" v-model="input.oldpassword" :class="textbox"/>
                                <span v-if="validated != null && validated.oldpassword.message1 == 'empty'" :class="validation">&nbsp; required field</span>
                            </div>
                            <div class="mb-5">
                                <div class="flex gap-2 items-center justify-start">
                                    <label class="mt-2" :class="label">New Password</label>
                                </div>
                                <input type="password" v-model="input.newpassword" :class="textbox"/>
                                <span v-if="validated != null && validated.newpassword.message1 == 'empty'" :class="validation">&nbsp; required field</span>
                            </div>
                            <div class="mb-5">
                                <div class="flex gap-2 items-center justify-start">
                                    <label class="mt-2" :class="label">Access Code</label>
                                </div>
                                <input type="password" v-model="input.accesscode" :class="textbox"/>
                                <span v-if="validated != null && validated.accesscode.message1 == 'empty'" :class="validation">&nbsp; required field</span>
                            </div>
                            <div class="flex justify-end">
                                <button @click="changepassword()" :disabled="isvalid==false" class="bg-green-500" :class="button">Change Password</button>
                            </div>
                        </InputTemplate>
                    </ValidationViewVue>
                </div>
            </div>
        </div>
        <AlertMessageVue :showModal="showalert" :msgmsg="msgmsg" @onClose="showalert=false"></AlertMessageVue>
    </div>
</template>

<script>

import SvgIcons from '../SvgIcons.vue';
import InputTemplate from '../InputTemplate.vue';
import ValidationViewVue from '../ValidationView.vue';
import AlertMessageVue from '../AlertMessage.vue';
import membership from '@/mixin/membership';

export default {
    mixins:[membership],
    components:{
        SvgIcons,
        InputTemplate,
        ValidationViewVue,
        AlertMessageVue
    },
    props: {
        showModal: Boolean
    },
    data(){
        return{
            input:{
                oldpassword: null,
                newpassword: null,
                accesscode: null
            },
            vinput:{
                oldpassword: { required: true, message1: null , error: false },
                newpassword: { required: true, message1: null , error: false },
                accesscode: { required: true, message1: null , error: false },
            },
            showalert: false,
            msgmsg: null
        }
    },
    methods:{
        async changepassword(){
            await this.axios.post("User/save-changepassword", this.input).then((response) => {
                if(response.data.message == "success"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("name");
                    localStorage.removeItem("cashierid");
                    window.location.href = this.loginurl
                }
                else{
                    this.showalert = true
                    this.msgmsg = "Unable to Change Password !"
                }
            })
        }
    }
}
</script>